export default __webpack_public_path__ + "static/media/aboutImg2.057a33db.jpg";